import React from 'react';
import * as RadixTabs from '@radix-ui/react-tabs';

import styles from './Tabs.module.css';

export type TabsProps = React.ComponentPropsWithoutRef<typeof RadixTabs.Root>;

export const Tabs = React.forwardRef<React.ElementRef<typeof RadixTabs.Root>, TabsProps>(
  ({ className, ...props }, ref) => (
    <RadixTabs.Root
      ref={ref}
      className={[styles.root, className].filter(Boolean).join(' ')}
      {...props}
    />
  )
);
Tabs.displayName = 'Tabs';

export type TabsListProps = React.ComponentPropsWithoutRef<typeof RadixTabs.List>;

export const TabsList = React.forwardRef<React.ElementRef<typeof RadixTabs.List>, TabsListProps>(
  ({ className, ...props }, ref) => (
    <RadixTabs.List
      ref={ref}
      className={[styles.list, className].filter(Boolean).join(' ')}
      {...props}
    />
  )
);
TabsList.displayName = 'TabsList';

export type TabsTriggerProps = React.ComponentPropsWithoutRef<typeof RadixTabs.Trigger>;

export const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof RadixTabs.Trigger>,
  TabsTriggerProps
>(({ className, ...props }, ref) => (
  <RadixTabs.Trigger
    ref={ref}
    className={[styles.trigger, className].filter(Boolean).join(' ')}
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

export type TabsContentProps = React.ComponentPropsWithoutRef<typeof RadixTabs.Content>;

export const TabsContent = React.forwardRef<
  React.ElementRef<typeof RadixTabs.Content>,
  TabsContentProps
>(({ className, ...props }, ref) => (
  <RadixTabs.Content
    ref={ref}
    className={[styles.content, className].filter(Boolean).join(' ')}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';
